import React from "react";

const PupilTimePoint = ({ formData, setFormData, timePoint, title }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const isVisible = formData[`${timePoint}_pupil`] === "Yes";

  return (
    <>
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">{title} Pupil :</label>
          <div className="input_1col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name={`${timePoint}_pupil`}
                value="Yes"
                checked={formData[`${timePoint}_pupil`] === "Yes"}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [`${timePoint}_pupil`]: e.target.value,
                  })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">Yes</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name={`${timePoint}_pupil`}
                value="No"
                checked={formData[`${timePoint}_pupil`] === "No"}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [`${timePoint}_pupil`]: e.target.value,
                  })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">No</div>
            </label>
          </div>
        </div>
      </div>

      {isVisible && (
        <div className="pupil-details" style={{ marginBottom: "20px" }}>
          {["Min", "Ch", "CV", "MCV", "LAT", "DV", "NPI", "Size"].map(
            (metric) => (
              <div className="input-wrapper-2column" key={metric}>
                <div className="block-2column">
                  <label className="item_title_2col">
                    {title} Lt {metric} :
                  </label>
                  <div className="input">
                    <div className="input-with-unit">
                      <input
                        type="text"
                        id={`${metric}_Lt_${timePoint}`}
                        name={`${metric}_Lt_${timePoint}`}
                        value={formData[`${metric}_Lt_${timePoint}`] || ""}
                        onChange={handleInputChange}
                      />
                      <span className="unit-text">
                        {metric === "Ch"
                          ? "%"
                          : metric === "LAT"
                          ? "sec"
                          : ["CV", "MCV", "DV"].includes(metric)
                          ? "mm/s"
                          : metric === "NPI"
                          ? ""
                          : "mm"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="block-2column">
                  <label className="item_title_2col">
                    {title} Rt {metric} :
                  </label>
                  <div className="input">
                    <div className="input-with-unit">
                      <input
                        type="text"
                        id={`${metric}_Rt_${timePoint}`}
                        name={`${metric}_Rt_${timePoint}`}
                        value={formData[`${metric}_Rt_${timePoint}`] || ""}
                        onChange={handleInputChange}
                      />
                      <span className="unit-text">
                        {metric === "Ch"
                          ? "%"
                          : metric === "LAT"
                          ? "sec"
                          : ["CV", "MCV", "DV"].includes(metric)
                          ? "mm/s"
                          : metric === "NPI"
                          ? ""
                          : "mm"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      )}
    </>
  );
};

export default PupilTimePoint;
